var render = function render(){var _vm=this,_c=_vm._self._c;return _c('section',{staticClass:"success-stories",attrs:{"id":"success-stories"}},_vm._l((_vm.successStories),function(storie,index){return _c('div',{key:index},[_c('h4',[_vm._v(_vm._s(storie.title))]),_c('div',{domProps:{"innerHTML":_vm._s(storie.body)}})])}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }